export const getApiErrorMessage = (error) => {

    const detail =
        error?.response?.data?.detail;

    if (Array.isArray(detail)) {

        return detail
            .map((err) => err.msg)
            .join(", ");

    }

    if (typeof detail === "string") {

        return detail;

    }

    return "Something went wrong";
};